<template>
    <div class="flex items-center">
        <button
            class="btn btn-xs btn-outline"
            title="Merknad"
            data-cy="remark-button"
            @click="showRemarksPopup()"
        >
            <i class="i-ph-pencil text-lg"/>
            Legg til
        </button>
        <span class="ml-2"> {{ remarks }}</span>
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'

const props = defineProps({
    params: {
        type: Object as () => any,
        required: true
    }
})

const remarks = computed(() => {
    return props.params.data.remarks
})

const showRemarksPopup = () => {
    props.params.showVatLineCommentDialog(
        props.params.data.remarks ?? '',
        (comments: string) => props.params.updateVatOptionComment(
            props.params.data.id,
            comments
        )
    )
}

</script>

<style scoped>

</style>